// Costi di imballaggio per tipo di confezione
export const PACKAGING_COSTS = {
    3: 1.50,
    6: 2.50,
    12: 3.50
};

// Costo spedizione per bottiglia
export const SHIPPING_COST_PER_BOTTLE = 3.40;

// 📦 FUNZIONE PER DECODIFICARE LA COMBINAZIONE IN SINGOLE CONFEZIONI
export const DecodePackCombinations = (quantity, availablePacks = [12, 6, 3]) => {
    const packs = [...availablePacks].sort((a, b) => b - a);
    
    let bestCombo = null;
    let minPacks = Infinity;
    
    const findBestCombination = (remaining, currentCombo, startIndex) => {
        if (remaining === 0) {
            if (currentCombo.length < minPacks) {
                minPacks = currentCombo.length;
                bestCombo = [...currentCombo];
            }
            return;
        }
        if (remaining < 0) return;
        if (currentCombo.length >= minPacks) return;
        
        for (let i = startIndex; i < packs.length; i++) {
            const pack = packs[i];
            if (pack <= remaining) {
                currentCombo.push(pack);
                findBestCombination(remaining - pack, currentCombo, i);
                currentCombo.pop();
            }
        }
    };
    
    findBestCombination(quantity, [], 0);
    
    if (!bestCombo) {
        return { packs: [] };
    }
    
    // Conta quante confezioni di ogni tipo
    const packCounts = {};
    bestCombo.forEach(pack => {
        packCounts[pack] = (packCounts[pack] || 0) + 1;
    });
    
    return {
        packs: bestCombo,
        packCounts: packCounts,
        totalQuantity: quantity
    };
};
